import { createContext, useContext } from "react";

import { Locale } from "date-fns";

import { Locale as AELocale } from "@/constants";

export type CurrencyFormatter = (amount: number) => string;
export type DateFormatter = (date: Date | string, dateFormat: string) => string;
export type DateRangeFormatter = (
  start: Date | string | undefined,
  end: Date | string | undefined,
  dateFormat: string
) => string;
export type NumberFormatter = (n: number) => string;

export type i18nContextType = {
  locale?: Locale;
  language: AELocale;
  currency: string;
  formatCurrency: CurrencyFormatter;
  formatDate: DateFormatter;
  formatDateRange: DateRangeFormatter;
  formatNumber: NumberFormatter;
  abbreviateNumber: NumberFormatter;
  abbreviateCurrency: NumberFormatter;
};

export const i18nContext = createContext<i18nContextType>(
  {} as i18nContextType
);

export const useI18n = () => useContext(i18nContext);
